import { containerDefault } from '../../lib/styles/Container'
import styled from 'styled-components'
import { IconWrapper } from '../../components/UI/Icon'
import { typoHeading6, typoParagraphS } from '../../lib/styles/Typography'
import { styleAnchor } from '../../lib/styles/Style'

export const StyledWrapper = styled.div`
  ${containerDefault}
  margin: 3rem auto;
`

export const StyledTableWrapper = styled.div`
  position: relative;

  &:after {
    position: absolute;
    display: block;
    content: '';
    top: 0;
    right: 0rem;
    background: rgb(255, 255, 255);
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    height: 100%;
    width: 1rem;
  }
`

export const StyledTableInner = styled.div`
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    height: 0.3rem;
    background: ${p => p.theme.colors.black[6]};
    border-radius: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background: ${p => p.theme.colors.black[4]};
    height: 0.15rem;
    border-radius: 0.25rem;

    &:hover {
      background: ${p => p.theme.colors.black[3]};
    }

    &:active {
      background: ${p => p.theme.colors.black[2]};
    }
  }

  padding-bottom: 1rem;
`

export const StyledTable = styled.div.attrs(props => ({
  role: 'table',
})) <{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns + 1}, 1fr);
  min-width: 40rem;

  > :nth-child(${({ columns }) => columns + 1}n) {
    position: relative;
  }
`
export const StyledTableHeaderCell = styled.div.attrs(props => ({
  role: 'cell',
}))`
  text-align: center;
  padding: 1rem 0.5rem;
  border-bottom: solid 1px ${({ theme }) => theme.colors.black[1]};
  ${typoHeading6}
`

export const StyledTableAsideCell = styled.div.attrs(props => ({
  role: 'cell',
}))`
  background-color: ${({ theme }) => theme.colors.white[1]};
  padding-right: 3rem;
  min-width: 12rem;
  padding: 0.6rem 0.5rem;
  position: sticky;
  left: 0;
  border-top: solid 1px ${({ theme }) => theme.colors.black[6]};
  ${typoParagraphS}

  display: flex;
  align-items: center;

  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    right: -1rem;
    background: rgb(255, 255, 255);
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    height: 100%;
    width: 1rem;
  }

  &:first-child {
    border-top: none;
    border-bottom: solid 1px ${({ theme }) => theme.colors.black[1]};
  }

  a {
    ${styleAnchor}
  }

  @media screen and (max-width: 480px) {
    min-width: 8rem;
  }
`

export const StyledTableCellCategoryNameCell = styled.div.attrs(props => ({
  role: 'cell',
})) <{ columns: number }>`
  position: sticky;
  left: 0;
  padding: 0.6rem 0.5rem 1.2rem 0.5rem;
  margin-top: 1.5rem;

  h3 {
    ${typoHeading6}
    color: ${({ theme }) => " #0D59F2"};
  }
`

export const StyledTableBodyCell = styled.div.attrs(props => ({
  role: 'cell',
})) <{ isAvalible: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  border-top: solid 1px ${({ theme }) => theme.colors.black[6]};
  padding: 0.6rem 0.5rem;
  text-align: center;

  ${IconWrapper} {
    color: ${({ isAvalible, theme }) => (isAvalible ? " #0D59F2" : theme.colors.black[4])};
    width: 1.2rem;
    height: 1.2rem;
  }
`
export const StyledOptionalNote = styled.span`
  font-size: 14px;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.black[4]};
`
